import React from "react";
import { Box, Divider } from "@mui/material";
import { ProductList } from "./ProductList";
import { PriceSummary } from "./PriceSummary";
import { CouponSection } from "./CouponSection";
import { rightColumnStyle } from "./CouponStyles";
import { CartItem } from "@ecommerce/store";

interface OrderSummarySectionProps {
  cartItems: CartItem[];
  priceSummary: PriceSummary;
  couponSectionProps?: any;
  hasSelectedShippingOption: boolean;
}

export const OrderSummarySection: React.FC<OrderSummarySectionProps> = ({
  cartItems,
  priceSummary,
  couponSectionProps,
  hasSelectedShippingOption,
}) => (
  <Box sx={rightColumnStyle}>
    <ProductList cartItems={cartItems} />
    <Divider sx={{ mb: 2 }} />
    <PriceSummary summary={priceSummary} hasSelectedShippingOption={hasSelectedShippingOption} />

    {
      !!couponSectionProps &&
        <CouponSection {...couponSectionProps} />
    }
    
  </Box>
);














